import { connect } from 'react-redux';
import { IAuthSettingsState } from '@piwikpro/auth-crate/reducers/auth';
import { withTranslation } from '@piwikpro/ui-components';
import TwoFactorConfirmCurrent from './TwoFactorConfirmCurrent';

export default withTranslation(['administration'])(
  connect(
    (state: { authSettings: IAuthSettingsState }) => ({
      failed: state.authSettings.user.setup.failed,
      twoFactorAuthEnforced: state.authSettings.user.twoFactorAuth.enforced,
    }),
    null,
  )(TwoFactorConfirmCurrent),
);
